export { load } from '@telerik/kendo-intl';



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-intl/dist/es/coreExports.js
// module id = 853
// module chunks = 93